export class Customer {
  constructor(
    public id: string,
    public name: string,
    public administrators?: string[],
    public created?: Date,
    public updated?: Date,
    public activityId?: string
  ) {}
}
